'use strict';
const angular = require('angular');

export class connectedSiteContentWidgetComponent {

  constructor($sce, IntegrationService) {
    'ngInject';

    this.$sce = $sce;
    this.IntegrationService = IntegrationService;
  }

  convertShortcode(html) {
    return html.replace(/\[/g,"<").replace(/\]/g,">");
  }

  $onInit() {
    this.IntegrationService.getConnectedSitePage({url: this.url, name: this.name}, page => {
      this.content = this.convertShortcode(page.data);
    })
  }
}

export default angular.module('conduuApp.connectedSiteContentWidget', [])
  .component('connectedSiteContentWidget', {
    template: `<div bind-dynamic-page='$ctrl.content'></div>`,
    bindings: {
      url: '@',
      name: '@'
    },
    controller: connectedSiteContentWidgetComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/sidebar/connected-site-content-widget/connected-site-content-widget.component.js